
const WEB_HOST = 'api.promocards.io';
// const WEB_HOST = '127.0.0.1:5000';


export default WEB_HOST;
